const ErrorText = ({ text }: { text: string }) => (
  <p className="relative -top-2.5 text-xs font-medium text-error mx-0.5 font-secondary text-left mb-1">{text}</p>
);

export default ErrorText;
